<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
            <h2>{{ $t("navigations.lab test") }}</h2>
        </div>
    </div>
    <div class="wrapper wrapper-content">
      <div class="ibox-content py-2 mb-1">
        <div class="d-flex flex-column flex-lg-row justify-content-lg-end my-2 my-lg-0">
          <div class="col-lg-5 mb-1 my-lg-0 pl-lg-0 pr-lg-1">
            <div class="form-group mb-0">
              <label class="mb-0">{{ $t("navigations.test code") }}</label>
              <input
                type="text"
                class="form-control my-lg-0"
                v-model="testCode"
              />
            </div>
          </div>
          <div class="col-lg-5 my-1 my-lg-0 pl-lg-0 pr-lg-1">
            <div class="form-group mb-0">
              <label class="mb-0">{{ $t("navigations.test name") }}</label>
              <input
                type="text"
                class="form-control my-lg-0"
                v-model="testName"
              />
            </div>
          </div>
            <span
            type="button"
              class="col-12 col-lg-2 save_btn w-100 align-self-end"
              @click.prevent="SearchButtonClicked()"
            >
              {{ $t("navigations.search") }}
            </span>            
        </div>
        </div>
        <div class="ibox-body">
            <div class="ibox-title style_2 d-flex justify-content-between">
                <h5>{{ $t("navigations.lab test list") }}</h5>
                           <div class="d-flex">
        <div class="position-relative align-self-center mr-3">
          <img class="cursor-pointer" src="../../assets/img/create.png"  alt="Create study" @click.prevent="createLabTest(0)"/>
          <div class="tool-tip">{{ $t("navigations.create lab test") }}</div>
        </div>
        
      
      </div>
            </div>
           
            <div class="ibox-content">
                <div class="text-center" v-if="showLoading === true">
                    <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
                    <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
                </div>
                <template v-else>
                    <div class="text-center" v-if="labList.length==0">
                        {{ $t('navigations.no data available') }}
                    </div>
                    <div v-else class="table-responsive">
                        <table class="table table-striped table-bordered dataTables">
                            <thead>
      <tr>
        <th class="sort_block" @click="SortSelected('testCode', 1)" id="1">
          <div class="d-flex flex-row justify-content-between">
            {{ $t("navigations.test code") }}
            <span>
              <i class="fa fa-long-arrow-up"></i>
              <i class="fa fa-long-arrow-down"></i>
            </span>
          </div>
        </th>

        <th class="sort_block" @click="SortSelected('testName', 2)" id="2">
          <div class="d-flex flex-row justify-content-between">
            {{ $t("navigations.test name") }}
            <span>
              <i class="fa fa-long-arrow-up"></i>
              <i class="fa fa-long-arrow-down"></i>
            </span>
          </div>
        </th>

        <th class="sort_block" @click="SortSelected('unit', 3)" id="3">
          <div class="d-flex flex-row justify-content-between">
            {{ $t("navigations.unit") }}
            <span>
              <i class="fa fa-long-arrow-up"></i>
              <i class="fa fa-long-arrow-down"></i>
            </span>
          </div>
        </th>

        <th class="sort_block" @click="SortSelected('category', 4)" id="4">
          <div class="d-flex flex-row justify-content-between">
            {{ $t("navigations.category") }}
            <span>
              <i class="fa fa-long-arrow-up"></i>
              <i class="fa fa-long-arrow-down"></i>
            </span>
          </div>
        </th>

        <th class="sort_block" @click="SortSelected('method', 5)" id="5">
          <div class="d-flex flex-row justify-content-between">
            {{ $t("navigations.method") }}
            <span>
              <i class="fa fa-long-arrow-up"></i>
              <i class="fa fa-long-arrow-down"></i>
            </span>
          </div>
        </th>

        <th>{{ $t("navigations.cdisc variable") }}</th>
        <th>{{ $t("navigations.fhir resource") }}</th>
        <th class="text-center">{{ $t("navigations.allow unit conversion") }}</th>
        <th class="text-center">{{ $t("navigations.status") }}</th>
        <th class="text-center">{{ $t("navigations.edit") }}</th>
        <th class="text-center">{{ $t("navigations.delete") }}</th>
      </tr>
                      </thead>
                            <tbody>
                              <tr v-for="lab in labList" :key="lab.testId || lab.id">
                                <!-- Test Id (from API) -->
                               

                                <!-- Existing fields -->
                                <td>{{ lab.testCode }}</td>
                                <td>{{ lab.testName }}</td>
                                <td>{{ lab.unit }}</td>
                                <td>{{ lab.category }}</td>
                                <td>{{ lab.method }}</td>
                                <td>{{ lab.cdiscVariable }}</td>
                                <td>
                                  <div>{{ lab.fhirResource }}</div>
                                </td>
                               
                                <td class="text-center">{{ lab.allowUnitConversion ? $t('navigations.yes') : $t('navigations.no') }}</td>
                                <td class="text-center">{{ lab.active === true? $t('navigations.active') : $t('navigations.inactive') }}</td>

                                <!-- Actions -->
                                <td class="text-center">
                                  <i class="fa fa-edit edit-delete" @click.prevent="editlabtest(lab.testId || lab.id)"></i>
                                </td>
                                <td class="text-center">
                                  <i class="fa fa-trash edit-delete" @click.prevent="deleteLabs(lab.testId || lab.id)"></i>
                                </td>
                              </tr>
                            </tbody>
                        </table>
                                   <div class="col-md-12 d-flex justify-content-md-end px-0" v-if="labList.length!=0">
              <VPagination
                v-model="currentPage"
                :pages="totalItems"
                :range-size="1"
                active-color="#ededed"
                @update:modelValue="loadPage"
              />
            </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script src="./labTest.js"></script>
<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";
.wrap-table-cell{
  min-width: 70ch;
  text-wrap-mode:wrap
 
}
input :disabled{
  cursor:not-allowed;
  opacity:1;
}
.previousbtn,.nextbtn{
  margin:0;
  border-radius:0px;
  border:0.5px solid #eeeeee;
}
.page-links{
  border-radius:0px;
}
.form-select{
  border-radius:0!important;
}
.form-select:focus{
  border-color:#145faf!important;
  box-shadow: 0 0 0!important;
}
.position-relative img{
  width:20px;
}
.cursor-pointer {
  cursor: pointer;
}
.position-relative {
  position: relative;
}
.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 0;
  top: -30px;
  font-size: 0.8rem;
 
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}
.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip{
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.modal__container22 {
  width: 33%;
  max-width: 30%;
  position: fixed;
  height: 20% !important;
  margin-top: -550px !important;
  margin-left: 409px !important;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.3s ease-in-out 0s;
}
.modal__container23 {
  width: 66%;
    max-width: 62%;
    position: fixed;
    height: -14% !important;
    margin-top: -683px !important;
    margin-left: 140px !important;
    background: rgb(255, 255, 255);
    border-radius: 4px;
    transition: all 0.3s ease-in-out 0s;
}
.scrollable3 {
  overflow-y: scroll;
  height: 250px;
}
.audit__details__modal__wrapper
{
  position: fixed;
  inset:0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index:3000
}
.audit__details__modal__container {
  width:min(90%,365px);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}
.audit__details__modal__title,
.audit__history__modal__title{
  background-color: var(--pop-up-background);
  color: #ffffff;
}
.heightBig
 {
  overflow-y: scroll;
  height: 250px;
}
.audit__history__modal__contents
 {
  overflow-y: scroll;
  height: 404px;
}
.audit__history__modal__wrapper{
  position: fixed;
  inset:0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index:4000
}
.audit__history__modal__container
{
  width:min(45%,90%);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}
</style>
 
 